import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import DragScrollProvider from 'drag-scroll-provider';
import userProfilImage from '../assets/icon_user_profile.svg';

import "./TeamLine.css";
import { Fade } from '@material-ui/core';

class TeamLine extends Component {

    render() {
            return (
                <TeamLineComponent />
            );
        }
    }

const INITIAL_STATE = {
    uID: '',
    users: [],
    team: [],
    teamPictures: [],
    error: null,
};

class TeamLineComponentBase extends Component {

    constructor(props) {
        super(props);
        this.state = { ...INITIAL_STATE };
    }

    componentDidMount() {

        this.props.firebase.auth.onAuthStateChanged(async (currentUser) => {

            if (currentUser === null) {
                return 
            }

        let querySnapshotUsers = await this.props.firebase.db.collection('users').where('manager','==',currentUser.uid).get();
        const team = querySnapshotUsers.docs.map(doc => doc.data())
        var teamPictures = [];
        
        team.forEach( function(teammate){
            if (teammate.image_url_profile !== null){
                teamPictures = teamPictures.concat([teammate.image_url_profile])
            }
            else teamPictures = teamPictures.concat([userProfilImage])
        })

        this.setState({team, teamPictures})
        });
    }

    render() {

        const picturesDisplay = [];
        let context = this;

        this.state.teamPictures.forEach( function(value,index){

            if (index === 0) {
                picturesDisplay.push(
                    <Fade in={true} key={index}>
                        <img className="first-picture" src={value || userProfilImage} alt="Profile" onError={context.props.firebase.profileImgError}/>
                    </Fade>
                )
            }
            else {
                picturesDisplay.push(
                    <Fade in={true} key={index}>
                        <img className="small-pictures" src={value || userProfilImage} alt="Profile" onError={context.props.firebase.profileImgError}/>
                    </Fade>)
            }
        })

        return (

            <div>
                <div className="team-title">
                    Mon équipe : les capsules d'amélioration
                </div>

                <div className="team-line-container">
                    <DragScrollProvider>
                    {({ onMouseDown, ref }) => (
                        <div className="team-line scrolling-wrapper"
                        ref={ref}
                        onMouseDown={onMouseDown}>

                            {picturesDisplay}
    
                        </div>
                    )}
                    </DragScrollProvider>
                </div>
            </div>
        );
    }
}

const TeamLineComponent = withRouter(withFirebase(TeamLineComponentBase));


export default TeamLine;
export { TeamLineComponent };